import { blob } from '@solana/buffer-layout';
import { toBigIntBE, toBigIntLE, toBufferBE, toBufferLE } from 'bigint-buffer';
import { encodeDecode } from './base.mjs';
export var bigInt = function bigInt(length) {
  return function (property) {
    var layout = blob(length, property);

    var _encodeDecode = encodeDecode(layout),
        encode = _encodeDecode.encode,
        decode = _encodeDecode.decode;

    var bigIntLayout = layout;

    bigIntLayout.decode = function (buffer, offset) {
      var src = decode(buffer, offset);
      return toBigIntLE(Buffer.from(src));
    };

    bigIntLayout.encode = function (bigInt, buffer, offset) {
      var src = toBufferLE(bigInt, length);
      return encode(src, buffer, offset);
    };

    return bigIntLayout;
  };
};
export var bigIntBE = function bigIntBE(length) {
  return function (property) {
    var layout = blob(length, property);

    var _encodeDecode2 = encodeDecode(layout),
        encode = _encodeDecode2.encode,
        decode = _encodeDecode2.decode;

    var bigIntLayout = layout;

    bigIntLayout.decode = function (buffer, offset) {
      var src = decode(buffer, offset);
      return toBigIntBE(Buffer.from(src));
    };

    bigIntLayout.encode = function (bigInt, buffer, offset) {
      var src = toBufferBE(bigInt, length);
      return encode(src, buffer, offset);
    };

    return bigIntLayout;
  };
};
export var u64 = bigInt(8);
export var u64be = bigIntBE(8);
export var u128 = bigInt(16);
export var u128be = bigIntBE(16);
export var u192 = bigInt(24);
export var u192be = bigIntBE(24);
export var u256 = bigInt(32);
export var u256be = bigIntBE(32);